<template>
  <div class="body-container">
    <div v-if="(!msisdnSubmitted && !isCampaign)">
      <div class="flex-wrap text-center text-box p-3">
        <span
            class="text-content"><strong>Please confirm your subscription, by clicking the confirm button below.</strong></span>
      </div>

      <div class="d-flex justify-content-center">
        <button class="join-now-button" @click="onConfirmClicked">CONFIRM</button>
      </div>
    </div>

    <div v-if="(!msisdnSubmitted && isCampaign)">
      <div class="flex-wrap text-center text-box p-3">
        <span
            class="text-content">Almost there! Please confirm your subscription to Zed Games at <b>{{ this.currencyAmount[0] }}</b>/{{ this.currencyAmount[1] }}.</span>
      </div>

      <div class="d-flex justify-content-center">
        <button class="join-now-button" @click="onSubscribeClicked">SUBSCRIBE</button>
      </div>
    </div>

    <div v-if="msisdnSubmitted">
      <div class="d-flex col justify-content-center pt-1" v-if="(!errorMessage&&!subscribeError)">
        <img class="col-12 col-sm-12 col-md-10 col-lg-12 col-xl-12 header-image"
             src="../assets/images/thank-you-img.png">
      </div>
      <div class="flex-wrap text-center text-box p-3" v-if="(!subscribeError)">
        <span class="text-content">Thank you! Your request is being processed.</span>
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="errorMessage">
        Please complete the sign up process and try again.
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="subscribeError">
        Error occurred please try again.
      </div>
      <div class="d-flex justify-content-center" v-if="subscribeError">
        <button @click="onRetryClicked"
                class="d-flex flex-row justify-content-center align-items-center continue-button">RETRY
        </button>
      </div>
    </div>
    <div class="d-flex flex-column flex-wrap text-center terms-and-conditions pt-3">
      <div>Subscription service.</div>
      <div>{{ this.currencyAmount[0] }}/{{ this.currencyAmount[1] }}.<a
          href="http://play.zedgames.mobi/terms-conditions"> T & C's Apply.</a></div>
    </div>
    <loading
        :show="showLoading"
        :label="loadingLabel">

    </loading>
  </div>
</template>

<script>
import loading from "vue-full-loading";
import {environmentConfig} from "@/config/environmentConfig";
import {mapMutations, mapState} from "vuex";
import router from "@/router";
import ZambiaIntegrationService from "@/services/zambiaIntegrationService";

export default {
  name: "ConfirmPage",
  computed: {
    ...mapState(["showWinDailyBanner", "currencyAmount", "campaignId", "trackerId", "publisherId"])
  },
  data() {
    return {
      msisdn: undefined,
      showLoading: false,
      loadingLabel: "Subscribing...",
      msisdnSubmitted: false,
      subscribeError: false,
      errorMessage: false,
      marketingCurrency: ['K1', 'Daily'],
      isCampaign: false
    };
  },
  beforeMount() {
    this.msisdn = this.$route.query.msisdn;
    const campaignId = this.$route.query.campaignId;
    const trackerId = this.$route.query.trackerId;
    const publisherId = this.$route.query.publisherId;
    this.setCampaignId(campaignId);
    this.setTrackerId(trackerId);
    this.setPublisher(publisherId);
    if (!this?.msisdn) {
      return router.push({path: '/wifi', query: {campaignId: campaignId, trackerId: trackerId, publisherId: publisherId}});
    }

    if (this.campaignId) {
      this.isCampaign = true;
      this.setCurrencyAmount(this.marketingCurrency);
    }
    // console.log(`campaignId: ${this.campaignId} currencyAmount: ${this.currencyAmount} campaignPage:${this.isCampaign}`);
  },
  methods: {
    ...mapMutations(["setShowWinDailyBanner", "setCampaignId", "setCurrencyAmount", "setTrackerId", "setPublisher"]),
    toggleLoadingAnimation(toggle = false) {
      this.showLoading = toggle;
    },
    async onConfirmClicked() {
      this.toggleLoadingAnimation(true);
      try {
        const subscribeResponse = await ZambiaIntegrationService.subscribe(this.msisdn, this.currencyAmount[1], this.campaignId, this?.trackerId, this?.publisherId);
        this.msisdnSubmitted = true;
        if (!subscribeResponse?.data?.isSuccess) {
          this.toggleLoadingAnimation(false);
          this.subscribeError = true;
        } else {
          this.toggleLoadingAnimation(false);
          this.setShowWinDailyBanner(false);
          window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
        }
      } catch (e) {
        this.toggleLoadingAnimation(false);
        this.msisdnSubmitted = true;
        this.subscribeError = true;
      }
    },
    async onSubscribeClicked() {
      await this.onConfirmClicked();
    }
  },
  components: {
    loading
  },
}
</script>

<style scoped>
.terms-and-conditions {
  font-family: 'MTNBrighterSans', sans-serif;
  font-weight: normal;
  font-size: 12px;
}
</style>
